import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import {Page} from "@indebted/components/Page"
import {TextToHTML} from "@indebted/components/TextToHTML"

function OptOutAlreadyCompleted({I18n}) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.Title}
				</Typography>
			</Grid>

			<Grid>
				<TextToHTML align="center" text={I18n.Subtitle} />
			</Grid>
		</Page>
	)
}
export {OptOutAlreadyCompleted}
